module.exports = __webpack_public_path__ + "static/media/img_16.ca76361a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_16.jpg
// module id = 534
// module chunks = 0